import React, { useState, useEffect } from 'react';

import { session } from '../../../services/session';
import { api } from '../../../services/api';
import { dateService } from '../../../services/date';
import DeveloperOptionsModal from './developer-options-modal';

const DeveloperOptions = () => {
  const [showModal, setShowModal] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [apiKeys, setApiKeys] = useState([]);

  const modal = showModal ? (
    <DeveloperOptionsModal
      setShowModal={setShowModal}
      showModal={showModal}
      apiId={modalData}
      getApiKeys={getApiKeys}
    />
  ) : null;

  useEffect(() => {
    getApiKeys();
  }, []);

  function getApiKeys() {
    api.get(`/api/v0/users/${session.userId}/api_keys/`).then(res => {
      setApiKeys(res.data.data);
    });
  }

  const apiKeyItems = apiKeys.map((apiKey, index) => {
    const toggleDisable = apiKey.is_enabled_by_user ? (
      <button onClick={() => setShowModal('disable')} className="disable-btn">
        Disable
      </button>
    ) : (
      <button onClick={() => setShowModal('enable')} className="enable-btn">
        Enable
      </button>
    );

    return (
      <div key={index} className={`api-key ${!apiKey.is_enabled_by_user ? 'disabled' : ''}`}>
        <span>
          <div>
            {apiKey.description}
            {!apiKey.is_enabled_by_user ? ' (Disabled)' : ''}
          </div>
          <div className="dates">
            <span>
              Created: {dateService.formatDisplayDate(apiKey.datetime_created)}&nbsp; at{' '}
              {dateService.formatTime(apiKey.datetime_created)}
            </span>
            <span>
              Last Used:&nbsp;
              {apiKey.datetime_last_used
                ? dateService.formatDisplayDate(apiKey.datetime_last_used)
                : 'Never'}
            </span>
          </div>
        </span>
        <span onClick={() => setModalData(apiKey.token_id)}>
          <button onClick={() => setShowModal('rename')} className="rename-btn">
            Rename
          </button>
          {toggleDisable}
          <button onClick={() => setShowModal('delete')} className="delete-btn">
            Delete
          </button>
        </span>
      </div>
    );
  });

  return (
    <div className="developer-options">
      {modal}
      <h3>API Keys</h3>
      <div className="section">
        <span className="description">
          Create API keys for your apps to grant them access to the Narrativ API and allow them to
          manage your account. You may have up to 5 API keys on your user account. Treat API keys
          like passwords and never share them with anyone.
        </span>
        <div>
          <button className="submit-btn" onClick={() => setShowModal('create')}>
            New API Key
          </button>
        </div>
      </div>
      <hr></hr>
      <div className="section">
        <div className="api-keys">{apiKeyItems}</div>
      </div>
    </div>
  );
};

export default DeveloperOptions;
